import axios from "axios";
import appConfig from "../../config/appConfig";

const api = axios.create({
  baseURL: appConfig.API_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const url = config?.url || "";

    const isRefreshRequest =
      url === "/auth/refresh" || url.endsWith("/auth/refresh");

    if (token && !isRefreshRequest) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;